import { Tooltip } from 'antd';
import { Info } from '@phosphor-icons/react';
import {
  BottomCard as Card,
  BottomCardHeader2,
  ContentValuesCardBottom,
  ContentTextValue,
} from './styles';

type Props = {
  label: string;
  value: string | number;
  subtitle?: string;
  helpText?: string;
  openModal?: (value: boolean) => void;
};

export const BottomCardGraphicNumber = ({
  label,
  value,
  subtitle,
  helpText,
  openModal,
}: Props) => {
  return (
    <Card
      onClick={() => {
        openModal && openModal(true);
      }}
      style={{ gap: '.5rem' }}
    >
      <BottomCardHeader2>
        <span>{label}</span>
        <Tooltip title={helpText}>
          <Info size="1rem" color="#EC6643" />
        </Tooltip>
      </BottomCardHeader2>

      <ContentValuesCardBottom style={{ justifyContent: 'flex-start' }}>
        <ContentTextValue>
          <strong style={{ fontSize: '2rem', lineHeight: 1.1 }}>
            {value ?? 0}
          </strong>
          {subtitle && <span>{subtitle}</span>}
        </ContentTextValue>
      </ContentValuesCardBottom>
    </Card>
  );
};